<template>
  <div class="form-group esma_form_group">
    <label v-bind:for="fieldID"
     :style="labelStyle"
     :class="{'col-xs-4':true, 'control-label':true, 'esma_form_label':true,'esma_error_field':showAsError}">
     {{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div class="col-xs-8" style="padding:1px 0px 1px 7px;">
      <input
      ref="local_value"
      type="password"
      class="form-control"
      @focus="atFocus()"
      v-bind:style="filedStyle"
      :disabled="isDisabled"
      autocapitalize="none"
      _autocomplete="off"
      autocomplete="new-password"
      v-on:input="updateValue($event.target.value)"
      v-bind:id="fieldID"
      v-bind:name="fieldID"
      v-bind:value="fieldValue"
      placeholder="">
    </div>

  </div>
</template>
<script>

import Vue from 'vue'
import _ from "lodash";
import debug from 'debug'
var debug_pass_box = debug("esma:pass_box")

export default {
  data(){
    return{
      show_modal_password:false,
      local_value : null,
      local_style: "",
      had_focus:false,
      local_refresh_sequecnce: 1,
      show_as_error:false
    }
  },


  computed: {
    isRequired(){
        return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },
    showAsError:{
      get(){
        return this.show_as_error;
      },
      set(v){
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce:{
      get(){
        return this.local_refresh_sequecnce;
      },
      set(v){
        this.local_refresh_sequecnce = v;
      }
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    labelStyle() {
      return (this.$props.data.label_style || "") + this.local_style;
    },
    apiName(){
      return this.$props.data.api_name;
    },

    fieldLabel() {
      return  this.$props.data.label
    },
    fieldValue() {
      var len = (this.$store.state[this.stateCurrentRow][this.fieldID])? this.$store.state[this.stateCurrentRow][this.fieldID].length : 0
      return (this.localRefreshSequecnce > 0) ?_.repeat("*",len):"";
    },
    fieldID() {
      return this.$props.data.id
    },
    isDisabled(){

      if(this.$store.state[this.stateIsEditingNew] == true){
        return  this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"; //TODO, can also has another field to force it.
      }
      var ret = this.$props.data.disabled ||  this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"
      if(ret && this.had_focus){
        this.had_focus = false;
      }
      return ret;
    },

    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      return "display: inline-block;width: 100%;" + store_style;
    }

  },
    methods:{
    atFocus(){
      console.log("atFocus ",this.had_focus);
      if(this.had_focus == false){
        console.log("atFocus false");
        this.had_focus=true;
        this.$store.state[this.stateCurrentRow][this.fieldID] = ""
      }
    },
    onClick(b){
      if(b.type=="add_to_input"){
          this.$refs.local_value.value = b.text
          this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text
      }
      if(b.type=="link"){
          this.$router.push(b.link) 
      }
      return false
    },
    updateValue(d){
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d
    }
  },
  mounted() {
    this.$props.data.ref_field = this;
    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        return cb(true);
      }
    }
  },
  props: ['data','value','date','read']
}
</script>
<style scoped>
.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control::selection {
  color: white;
  background: #575757;
}
.form-control[disabled],  fieldset[disabled] .form-control {
  background-color: #cccccc;
}
.form-control {
  color:black;
    height: 24px;
}
</style>


// WEBPACK FOOTER //
// password-box.vue?5cf5eb23